import { useEffect, useState } from "react";
import { Check, Trash2, Star } from "lucide-react";
import { toast } from "sonner";
import { api } from "../lib/api";
import { StatusBadge, thCls, tdCls } from "./ui";

export default function Reviews() {
  const [reviews, setReviews] = useState(null);

  const load = () => api.get("/admin/reviews").then((r) => setReviews(r.data || [])).catch(() => setReviews([]));
  useEffect(() => { load(); }, []);

  const approve = async (id) => {
    await api.patch(`/admin/reviews/${id}`, { status: "approved" }).catch(() => {});
    toast.success("Review approved.");
    load();
  };

  const remove = async (id) => {
    if (!window.confirm("Delete this review?")) return;
    await api.delete(`/admin/reviews/${id}`).catch(() => {});
    load();
  };

  return (
    <div data-testid="admin-reviews">
      <p className="text-sm text-stone2 mb-6">Visitor reviews arrive as pending — approve the genuine ones, delete the rest.</p>
      <div className="bg-white rounded-xl border border-[#E6DED3] shadow-sm overflow-x-auto">
        <table className="w-full text-left min-w-[720px]" data-testid="reviews-table">
          <thead className="border-b border-sand">
            <tr><th className={thCls}>Listing</th><th className={thCls}>Reviewer</th><th className={thCls}>Rating</th><th className={thCls}>Review</th><th className={thCls}>Status</th><th className={thCls}>Actions</th></tr>
          </thead>
          <tbody className="divide-y divide-sand">
            {(reviews || []).map((r) => (
              <tr key={r.id} data-testid={`review-row-${r.id}`}>
                <td className={`${tdCls} font-semibold`}>{r.listing_name}</td>
                <td className={tdCls}>{r.name}</td>
                <td className={tdCls}>
                  <span className="flex gap-0.5">
                    {[...Array(5)].map((_, i) => (
                      <Star key={i} className={`w-3.5 h-3.5 ${i < r.rating ? "fill-gold text-gold" : "text-sand"}`} />
                    ))}
                  </span>
                </td>
                <td className={`${tdCls} max-w-xs`}><p className="line-clamp-2 text-clay">{r.text}</p></td>
                <td className={tdCls}><StatusBadge status={r.status} /></td>
                <td className={tdCls}>
                  <div className="flex gap-1">
                    {r.status !== "approved" && (
                      <button title="Approve" onClick={() => approve(r.id)} className="p-2 text-jade hover:bg-jade-light rounded-lg" data-testid={`approve-review-${r.id}`}><Check className="w-4 h-4" /></button>
                    )}
                    <button title="Delete" onClick={() => remove(r.id)} className="p-2 text-ruby hover:bg-ruby-light rounded-lg" data-testid={`delete-review-${r.id}`}><Trash2 className="w-4 h-4" /></button>
                  </div>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
        {reviews && reviews.length === 0 && <p className="px-5 py-10 text-sm text-stone2 text-center">No reviews yet.</p>}
      </div>
    </div>
  );
}
